import { ChangeDetectionStrategy, Component, ElementRef, effect, inject, input } from '@angular/core';
import { UI_ICONS } from './icon-registry';

/** UI Icon/* del DS (24×24, trazo 1.8, color = currentColor). */
@Component({
  selector: 'cr-icon',
  standalone: false,
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'aria-hidden': 'true', class: 'cr-icon', '[style.width.px]': 'size()', '[style.height.px]': 'size()' },
  styles: [':host{display:inline-flex;flex:none;line-height:0} :host ::ng-deep svg{width:100%;height:100%;display:block}'],
})
export class IconComponent {
  readonly name = input.required<string>();
  readonly size = input<number>(20);
  private el = inject(ElementRef<HTMLElement>);

  constructor() {
    effect(() => {
      const body = UI_ICONS[this.name()] ?? '';
      this.el.nativeElement.innerHTML = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">${body}</svg>`;
    });
  }
}
